import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DashboardConfigurationComponent } from './dashboard-configuration/dashboard-configuration.component';
import { LocationService } from 'app/masters/location-master/location.service';
import { FormBuilder, FormControl, FormGroup, Validators, } from "@angular/forms";
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import { EMRService } from 'app/EMR/EMR.service';
import { AuthService } from 'app/auth/auth.service';
@Component({
  selector: 'app-company-master',
  templateUrl: './company-master.component.html',
  styleUrls: ['./company-master.component.scss']
})
export class CompanyMasterComponent implements OnInit {
  public regionalLangData: any[] = [];
  public fontfamilyArray: any[] = [];
  langControl: FormControl;
  fontControl: FormControl;
  filteredlangArray: Observable<any[]>;
  filteredFontArray: Observable<any[]>;
  companyForm: FormGroup;
  languageForm: FormGroup;
  billingpayLoad: any
  SavingPayLoad: any;
  displayedColumns: string[] = ['languageName', 'shortName', 'fontName', 'isActive'];
  companyColumns: string[] = ['companyName', 'address', 'mpstNo', 'cstNo', 'cinNo', 'isActive', 'centerStore'];
  datasourcecompany = new MatTableDataSource<any>([]);
  dataSource = new MatTableDataSource<any>([]);
  enabledisablebtn: boolean = false;
  enablesaveButton: boolean = false;
  originalData: { languageName: any; fontName: any; shortName: any; isActive: any; pkLanguageId: any; };
  billingCompanies: any;
  prefixes: any;
  public companyData: any[] = [];
  originalcompany: { CompanyName: any; address: any; mpstNo: any; cstNo: any; CINNo: any; isActivecompany: any; isCenterStore: any; language: any; PK_CompanyId: any; };
  serachLanguage: string;
  searchComplimaster: any;

  constructor(public dialog: MatDialog, public locationService: LocationService, private fb: FormBuilder,
    public emrService: EMRService, public authService: AuthService
  ) { }

  ngOnInit(): void {
    this.getlanguage(0);
    this.loadcompanyForm()
    this.loadlanguageForm()
    // this.dataSource.filterPredicate = this.createFilter();
    // this.datasourcecompany.filterPredicate = this.createFilters();
    this.getfontFamily()
    this.getbillingCompany()
    this.getPrefix()
    this.getCompany()
  }

  dashboardConfiguration() {
    const dialogRef = this.dialog.open(DashboardConfigurationComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "70%",
      width: "70%",
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }
  loadcompanyForm() {
    this.enablesaveButton = true;
    this.companyForm = this.fb.group({
      CompanyName: ['', Validators.required],
      address: ['', Validators.required],
      mpstNo: ['', Validators.required],
      cstNo: ['', Validators.required],
      CINNo: ['', Validators.required],
      isActivecompany: [false],
      isCenterStore: [false],
      headerLogo: [''],
      footerLogo: [''],
      language: [''],
      PK_CompanyId: 0
    });
  }

  loadlanguageForm() {
    this.enabledisablebtn = true;
    this.languageForm = this.fb.group({
      languageName: ['', Validators.required],
      fontName: ['', Validators.required],
      shortName: ['', Validators.required],
      isActive: [false],
      pkLanguageId: 0
    });
  }

  clearlanguageForm() {
    this.languageForm.reset();
    this.enabledisablebtn = true;
  }
  getlanguage(id) {
    this.locationService.getlanguage(id).subscribe((data: any) => {
      this.regionalLangData = data
      this.dataSource.data = this.regionalLangData;
      if (this.regionalLangData && this.regionalLangData.length) {
        this.initializelangControl();
      }
    });
  }

  initializelangControl() {
    this.langControl = new FormControl();
    this.filteredlangArray = this.langControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        return typeof value === 'string' ? this.filterlang(value) : this.regionalLangData;
      })
    );
  }


  filterlang(value: string): any[] {
    return this.regionalLangData?.filter(lang =>
      lang.languageName.toLowerCase().includes(value.toLowerCase())
    ) || [];
  }

  displayLangFn(lang: any): string {
    if (!lang) return '';
    return typeof lang === 'string' ? lang : lang.languageName;
  }
  getfontFamily() {
    this.fontfamilyArray = this.emrService.fontFamilies;
    this.initializeFontControl();
  }
  initializeFontControl(): void {
    this.fontControl = new FormControl();
    this.filteredFontArray = this.fontControl.valueChanges.pipe(
      startWith(''),
      map((font) =>
        font ? this.filterFont(font) : this.fontfamilyArray.slice()
      )
    );
  }

  filterFont(name: string): any[] {
    return this.fontfamilyArray.filter((font) =>
      font.fontName.toLowerCase().includes(name.toLowerCase())
    );
  }
  addRegionalLang() {
    document.getElementById("languageModal").style.display = "block";
  }
  closelanguageModal() {
    document.getElementById("languageModal").style.display = "none";
    this.clearlanguageForm()
  }

  enableButton() {
    const form = this.languageForm.controls;
    if (
      form.shortName.value === '' ||
      form.fontName.value === '' ||
      form.languageName.value === '' ||
      form.languageName.value == null ||
      form.fontName.value == null ||
      form.shortName.value == null
    ) {
      this.enabledisablebtn = true;
    } else {
      this.enabledisablebtn = false;
    }
  }
  savelanguage(event) {
    if (this.languageForm.controls.languageName.value) {
      if (this.languageForm.controls.shortName.value) {
        if (this.languageForm.controls.fontName.value) {
          const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
          button.setAttribute('disabled', true);
          const form = this.languageForm.controls;
          const formData = {
            languageName: form.languageName.value,
            shortName: form.shortName.value,
            fontName: form.fontName.value,
            isActive: form.isActive.value,
            pkLanguageId: form.pkLanguageId.value
          };

          if (!formData.pkLanguageId || formData.pkLanguageId == 0) {
            const existingLanguage = this.regionalLangData.filter(lang =>
              lang.languageName.toLowerCase() == form.languageName.value.toLowerCase()
            );
            if (existingLanguage.length > 0) {
              this.locationService.openSnackBar("Already exists in the list", "OK");
              this.clearlanguageForm();
              return;
            }
            this.SavingPayLoad = {
              "LanguageMaster": {
                PK_LanguageId: 0,
                LanguageName: formData.languageName,
                FontName: formData.fontName,
                ApplicationTypeId: 0,
                ShortName: formData.shortName,
                IsActive: formData.isActive || false,
                IsEdit: false,
                IsDelete: false
              }
            };

            this.locationService.addLanguage(this.SavingPayLoad).subscribe(data => {
              if (data.statusCode == 1) {
                this.locationService.openSnackBar("Record Saved successfully", "OK");
                this.clearlanguageForm();
                this.getlanguage(0);
                this.closelanguageModal()
                this.enabledisablebtn = true;
              }
            },
            err => {
              if (err.status == 403) {
                this.locationService.openSnackBar("You Don't have Permission", "OK");
              } 
              else if(err.error.statusCode == 422){
                this.locationService.openSnackBar(err.error.message,"OK");
              }
              else {
                this.locationService.openSnackBar("API Failed", "OK");
              }
            });
          } else {
            this.SavingPayLoad = {
              "LanguageMaster": {
                PK_LanguageId: formData.pkLanguageId,
                LanguageName: formData.languageName,
                FontName: formData.fontName,
                ApplicationTypeId: 0,
                ShortName: formData.shortName,
                IsActive: formData.isActive || false,
                IsEdit: true,
                IsDelete: false
              }
            };

            this.locationService.addLanguage(this.SavingPayLoad).subscribe(data => {
              if (data.statusCode == 1) {
                this.locationService.openSnackBar("Record Updated successfully", "OK");
                this.clearlanguageForm();
                this.getlanguage(0);
                this.closelanguageModal();
                this.enabledisablebtn = true;
              }
            },
            err => {
              if (err.status == 403) {
                this.locationService.openSnackBar("You Don't have Permission", "OK");
              } 
              else if(err.error.statusCode == 422){
                this.locationService.openSnackBar(err.error.message,"OK");
              }
              else {
                this.locationService.openSnackBar("API Failed", "OK");
              }
            }
          );
          }
        } else {
          this.locationService.openSnackBar("Font Name Required", "OK");
        }
      } else {
        this.locationService.openSnackBar("Short Name Required", "OK");
      }
    } else {
      this.locationService.openSnackBar("Language Name Required", "OK");
    }
  }

  openSearchModal() {
   
    document.getElementById("searchlanguageModal").style.display = "block";
    this.getlanguage(0)
  }
  closesearchModal() {
    document.getElementById("searchlanguageModal").style.display = "none";
    this.serachLanguage = ''
    this.dataSource.filter= ''
  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  createFilter(): (data: any, filter: string) => boolean {
    return (data, filter): boolean => {
      const transformedFilter = filter.trim().toLowerCase();
      return (
        data.languageName?.toLowerCase().includes(transformedFilter) ||
        data.shortName?.toLowerCase().includes(transformedFilter) ||
        data.fontName?.toLowerCase().includes(transformedFilter) ||
        (data.isActive ? 'active' : 'inactive').includes(transformedFilter)
      );
    };
  }


  selectRow(row: any): void {
    this.languageForm.patchValue({
      languageName: row.languageName,
      fontName: row.fontName,
      shortName: row.shortName,
      isActive: row.isActive,
      pkLanguageId: row.pK_LanguageId
    });
    this.originalData = {
      languageName: row.languageName,
      fontName: row.fontName,
      shortName: row.shortName,
      isActive: row.isActive,
      pkLanguageId: row.pK_LanguageId
    };
    this.enabledisablebtn = false;
    this.closesearchModal();
  }
  addRow() {
    const lastRow = this.billingCompanies[this.billingCompanies.length - 1];
    if (lastRow && !lastRow.billingCompany) {
      this.locationService.openSnackBar("Please complete the current row before adding a new one.", "OK");
      return;
    }
    this.billingCompanies.forEach((company) => (company.isEditing = false));
    const newRow = {
      pkBillingCompanyId: 0,
      billingCompany: '',
      isActive: false,
      isEditing: true
    };

    this.billingCompanies.push(newRow);
  }

  editRow(index: number,type:any) {
    this.billingCompanies.forEach((row) => (row.isEditing = false));
    this.billingCompanies[index].isEditing = type ==0?true:false;
  }

  addRow1() {
    const lastRow = this.prefixes[this.prefixes.length - 1];
    if (lastRow && (!lastRow.prefixName || !lastRow.prefixCode || !lastRow.colorCode)) {
      this.locationService.openSnackBar("Please complete the current row before adding a new one.", "OK");
      return;
    }
    this.prefixes.forEach((prefix) => (prefix.isEditing = false));
    const newRow = {
      pK_TranId: 0,
      prefixName: '',
      prefixCode: '',
      colorCode: '#000000',
      isEditing: true
    };
    this.prefixes.push(newRow);
  }


  editRow1(index: number,type:any) {
    this.prefixes.forEach((prefix) => (prefix.isEditing = false));
    this.prefixes[index].isEditing = type ==0?true:false;
  }


  getbillingCompany() {
    this.locationService.getbillingCompany().subscribe((data: any) => {
      this.billingCompanies = data
    });

  }

  getPrefix() {
    this.locationService.getPrefix().subscribe((data: any) => {
      this.prefixes = data
    });
  }


  saveCompanyMaster(event) {
    const form = this.companyForm.controls;
    const selectedLang = this.regionalLangData.find(lang => lang.languageName == this.langControl?.value?.languageName);
    const formData = {
      CompanyName: form.CompanyName.value,
      Address: form.address.value,
      MPSTNo: form.mpstNo.value,
      CSTNo: form.cstNo.value,
      CINNo: form.CINNo.value,
      IsActive: form.isActivecompany.value,
      FK_RegionalLanguageId: selectedLang ? selectedLang.pK_LanguageId : null,
      IsCenterStore: form.isCenterStore.value,
      HeaderLogo: form.headerLogo.value,
      FooterLogo: form.footerLogo.value,
      language: form.language.value,
      PK_CompanyId: form.PK_CompanyId.value
    };
  
    if (!formData.PK_CompanyId || formData.PK_CompanyId == 0) {
      const existingCompany = this.companyData.filter(company =>
        company.companyName.toLowerCase() == form.CompanyName.value.toLowerCase()
      );
      if (existingCompany.length > 0) {
        this.locationService.openSnackBar("Already exists in the list", "OK");
        this.clearcompanyForm()
        this.enabledisablebtn = true;
        return;
      }
      const companyMasterData = {
        PK_CompanyId: 0,
        CompanyName: formData.CompanyName,
        Address: formData.Address || '',
        MPSTNo: formData.MPSTNo || '',
        CSTNo: formData.CSTNo || '',
        CINNo: formData.CINNo || '',
        IsActive: formData.IsActive,
        FK_RegionalLanguageId: selectedLang ? selectedLang.pK_LanguageId : null,
        IsCenterStore: formData.IsCenterStore,
        SMSContactNo: "",
        HeaderLogo: formData.HeaderLogo || '',
        FooterLogo: formData.FooterLogo || '',
        PasswordPolicy: "N",
        ShowBranchCode: "N",
        OpticalStockAcceptProcess: "N",
        LastSMSSentDate: this.authService.localDate,
        IsEdit: false,
      };

      const bCompaniesData = this.billingCompanies?.map(billing => ({
        PK_BillingCompanyId: billing?.pkBillingCompanyId || 0,
        BillingCompany: billing?.billingCompany || '',
        Line1: null,
        Line2: null,
        Line3: null,
        Line4: null,
        Line5: null,
        IsActive: billing?.isActive ?? true,
        IsEdit: billing?.pkBillingCompanyId > 0 ? true : false
      })) || [];
      var billingCompaniesData = [];
      if (bCompaniesData.length > 0) {
        billingCompaniesData = bCompaniesData.filter(x => x.BillingCompany != '' && x.BillingCompany != null);
      }
      const prefixxData = this.prefixes?.map(prefix => ({
        PK_TranId: prefix?.pK_TranId || 0,
        PrefixName: prefix?.prefixName || '',
        PrefixCode: prefix?.prefixCode || '',
        ColorCode: prefix?.colorCode || '',
        IsEdit: prefix?.pK_TranId > 0 ? true : false
      })) || [];
      var prefixData = [];
      if (prefixxData.length > 0) {
        prefixData = prefixxData.filter(xy => xy.PrefixName != '' && xy.PrefixName != null)
      }
      
    const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
      const payload = {
        InsertCompanyMasterDto: companyMasterData,
        InsertBillingCompanyMasterDto: billingCompaniesData,
        InsertPrefixMasterDto: prefixData
      };

      this.locationService.addCompany(payload).subscribe(response => {
        if (response && response.statusCode == 1) {
          this.locationService.openSnackBar("Record saved successfully", "OK");
          this.clearcompanyForm();
          this.getCompany()
          this.getPrefix()
          this.getbillingCompany()
          this.billingCompanies.forEach(billing => billing.isEditing = false);
          this.prefixes.forEach(prefix => prefix.isEditing = false);
        }
        else if (response && response.statusCode == 10) {
          this.locationService.openSnackBar(response.message, "OK");
          this.clearcompanyForm();
          this.getCompany()
          this.getPrefix()
          this.getbillingCompany()
          this.billingCompanies.forEach(billing => billing.isEditing = false);
          this.prefixes.forEach(prefix => prefix.isEditing = false);
        }
      },
      err => {
       button.removeAttribute('disabled');
        if (err.status == 403) {
          this.locationService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.locationService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.locationService.openSnackBar("API Failed", "OK");
        }
      }
      );
    } else {
      const companyMasterData = {
        PK_CompanyId: formData.PK_CompanyId,
        CompanyName: formData.CompanyName,
        Address: formData.Address || '',
        MPSTNo: formData.MPSTNo || '',
        CSTNo: formData.CSTNo || '',
        CINNo: formData.CINNo || '',
        IsActive: formData.IsActive,
        FK_RegionalLanguageId: selectedLang ? selectedLang.pK_LanguageId : null,
        IsCenterStore: formData.IsCenterStore,
        SMSContactNo: "",
        PasswordPolicy: "N",
        ShowBranchCode: "N",
        OpticalStockAcceptProcess: "N",
        LastSMSSentDate: this.authService.localDate,
        IsEdit: true,
      };

      const bCompaniesData = this.billingCompanies?.map(billing => ({
        PK_BillingCompanyId: billing?.pkBillingCompanyId || 0,
        BillingCompany: billing?.billingCompany || '',
        Line1: null,
        Line2: null,
        Line3: null,
        Line4: null,
        Line5: null,
        IsActive: billing?.isActive ?? true,
        IsEdit: billing?.pkBillingCompanyId > 0 ? true : false
      })) || [];
      var billingCompaniesData = [];
      if (bCompaniesData.length > 0) {
        billingCompaniesData = bCompaniesData.filter(x => x.BillingCompany != '' && x.BillingCompany != null);
      }
      const prefixxData = this.prefixes?.map(prefix => ({
        PK_TranId: prefix?.pK_TranId || 0,
        PrefixName: prefix?.prefixName || '',
        PrefixCode: prefix?.prefixCode || '',
        ColorCode: prefix?.colorCode || '',
        IsEdit: prefix?.pK_TranId > 0 ? true : false
      })) || [];
      var prefixData = [];
      if (prefixxData.length > 0) {
        prefixData = prefixxData.filter(xy => xy.PrefixName != '' && xy.PrefixName != null)
      }
      
    const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
      const payload = {
        InsertCompanyMasterDto: companyMasterData,
        InsertBillingCompanyMasterDto: billingCompaniesData,
        InsertPrefixMasterDto: prefixData
      };
      this.locationService.addCompany(payload).subscribe(response => {
        if (response && response.statusCode == 1) {
          this.locationService.openSnackBar("Record updated successfully", "OK");
          this.clearcompanyForm();
          this.getCompany()
          this.getPrefix()
          this.getbillingCompany()
          this.billingCompanies.forEach(billing => billing.isEditing = false);
          this.prefixes.forEach(prefix => prefix.isEditing = false);
        }
        else if (response && response.statusCode == 10) {
          this.locationService.openSnackBar(response.message, "OK");
          this.clearcompanyForm();
          this.getCompany()
          this.getPrefix()
          this.getbillingCompany()
          this.billingCompanies.forEach(billing => billing.isEditing = false);
          this.prefixes.forEach(prefix => prefix.isEditing = false);
        }
      },
      err => {
      button.removeAttribute('disabled');
        if (err.status == 403) {
          this.locationService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.locationService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.locationService.openSnackBar("API Failed", "OK");
        }
      }
      );
    }

  }

  clearcompanyForm() {
    this.companyForm.reset();
    this.enablesaveButton = true;
    this.langControl.reset();

  }
  
  searchCompanyMaster() {
    document.getElementById("companylistModal").style.display = "block";
  }

  closeCompanyModal() {
    document.getElementById("companylistModal").style.display = "none";
    this.searchComplimaster = ''
    this.datasourcecompany.data = this.originalCompanyData;
  }

originalCompanyData: any[] = [];
  getCompany() {
    this.locationService
      .getcompany(0).subscribe((data: any) => {
        this.companyData = data;
           this.originalCompanyData = data;
        this.datasourcecompany = new MatTableDataSource(this.companyData);
      });
  }

  onSearch(searchTerm: string) {
  const lowerSearchTerm = searchTerm.toLowerCase();

 const dataArray = this.originalCompanyData;

  if (!lowerSearchTerm) {
    this.datasourcecompany.data = this.originalCompanyData;
    return;
  }
  const exactMatches = dataArray
    .map((item, index) => ({ ...item, _originalIndex: index }))
    .filter(item =>
      (item.companyName && item.companyName.toLowerCase() === lowerSearchTerm) ||
      (item.address && item.address.toLowerCase() === lowerSearchTerm) ||
      (item.mpstNo && item.mpstNo.toLowerCase() === lowerSearchTerm) || 
      (item.cstNo && item.cstNo.toLowerCase() === lowerSearchTerm) ||
      (item.cinNo && item.cinNo.toLowerCase() === lowerSearchTerm)
    );

  const partialMatches = dataArray
    .map((item, index) => ({ ...item, _originalIndex: index }))
    .filter(item =>
      (
        (item.companyName && item.companyName.toLowerCase().includes(lowerSearchTerm)) ||
        (item.address && item.address.toLowerCase().includes(lowerSearchTerm)) ||
        (item.mpstNo && item.mpstNo.toLowerCase().includes(lowerSearchTerm)) ||
        (item.cstNo && item.cstNo.toLowerCase().includes(lowerSearchTerm)) ||
        (item.cinNo && item.cinNo.toLowerCase().includes(lowerSearchTerm))
      ) &&
      !exactMatches.find(m => m._originalIndex === item._originalIndex)
    );

  this.datasourcecompany.data = [...exactMatches, ...partialMatches];
}


  selectcompanyRow(row: any): void {
    const selectedLang = this.regionalLangData.find(lang => lang.pK_LanguageId == row.fK_RegionalLanguageId);
    this.companyForm.patchValue({
      CompanyName: row.companyName,
      address: row.address,
      mpstNo: row.mpstNo,
      cstNo: row.cstNo,
      CINNo: row.cinNo,
      isActivecompany: row.isActive,
      isCenterStore: row.isCenterStore,
      language: selectedLang ? selectedLang.languageName : '',
      PK_CompanyId: row.pK_CompanyId,
    });

    this.originalcompany = {
      CompanyName: row.companyName,
      address: row.address,
      mpstNo: row.mpstNo,
      cstNo: row.cstNo,
      CINNo: row.cinNo,
      isActivecompany: row.isActive,
      isCenterStore: row.isCenterStore,
      language: row.fK_RegionalLanguageId,
      PK_CompanyId: row.pK_CompanyId,
    };
    this.closeCompanyModal()
    this.enablesaveButton = false;
    this.langControl.setValue(selectedLang.languageName);
  }
  enbaleSave() {
    const form = this.companyForm.controls;
    if (form.CompanyName.value === '' || form.CompanyName.value == null)
      {
      this.enablesaveButton = true;
    } else {
      this.enablesaveButton = false;
    }
  }
 
}